import React from 'react'
import PropTypes from 'prop-types'

import { ResourceDetailsBlock } from '../../ProjectDescription.styles'

function ReservoirsDescription({ title, suppliedBy, capacity, lang }) {
  return (
    <>
      <ResourceDetailsBlock>
        <div className="label">
          {lang === 'en' ? `Supplied By` : `مصدر التغذية`}
        </div>
        <div
          className={`value ${
            Array.isArray(suppliedBy[lang]) ? 'block' : 'default'
          }`}
        >
          {Array.isArray(suppliedBy[lang]) ? (
            <ul>
              {suppliedBy[lang].map((source, index) => (
                <li key={`${title.en}-${lang}-s-${index}`}>{source}</li>
              ))}
            </ul>
          ) : (
            suppliedBy[lang]
          )}
        </div>
      </ResourceDetailsBlock>
      <ResourceDetailsBlock>
        <span className="label">
          {lang === 'en' ? 'Capacity (m³)' : 'السعة (م٣)'}
        </span>
        <span className="value">{capacity}</span>
      </ResourceDetailsBlock>
    </>
  )
}

ReservoirsDescription.propTypes = {
  title: PropTypes.object,
  suppliedBy: PropTypes.object,
  capacity: PropTypes.string,
  lang: PropTypes.string
}

export default ReservoirsDescription
